import React, { useEffect, useRef } from 'react';
import classes from './Modal.module.css';
import modalCloseIcon from '../../Images/modal-close-icon.svg';

function Modal({ children, type, insideWizard, isPasscodeModal }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const modal = modalRef.current;

    if (!modal) return;

    const focusableContent = modal.querySelectorAll(focusableElements);
    const firstFocusableElement = focusableContent && focusableContent.length > 0 ? focusableContent[0] : null;
    const lastFocusableElement = focusableContent && focusableContent.length > 0 ? focusableContent[focusableContent.length - 1] : null;

    if (firstFocusableElement) firstFocusableElement.focus();

    const handleTabKey = (e) => {
      if (!focusableContent || focusableContent.length === 0) return;

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            if (lastFocusableElement) lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            if (firstFocusableElement) firstFocusableElement.focus();
          }
        }
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        const closeButton = modal.querySelector(`.${classes['modal__close']}`);
        if (closeButton) closeButton.click(); 
      }
    };

    modal.addEventListener('keydown', handleTabKey);
    modal.addEventListener('keydown', handleKeyDown);

    return () => {
      modal.removeEventListener('keydown', handleTabKey);
      modal.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      ref={modalRef}
      role="dialog"
      aria-modal="true"
      className={`${classes['modal']} ${type === 'fixed' ? classes['modal--fixed'] : ""} 
      ${insideWizard ? classes['modal--inside-wizard'] : ""} ${isPasscodeModal ? classes['passcode-modal'] : ""}`}
    >
      {children}
    </div>
  );
}

Modal.Dialog = ({ children, style, className = '' }) => {
  return (
    <div className={`${classes['modal__dialog']} ${className}`} style={style}>
      {children}
    </div>
  );
};


Modal.Header = ({ children, style }) => {
  return (
    <div className={`${classes['modal__header']}`} style={style}>
      {children}
    </div>
  );
};

Modal.Title = ({ children, style }) => {
  return (
    <div className={`${classes['modal__title']}`} style={style}>
      {children}
    </div>
  );
};

Modal.Body = ({ children }) => {
  return (
    <div className={`${classes['modal__body']}`}>
      {children}
    </div>
  );
};

Modal.Close = ({ onClick }) => {
  return (
    <button onClick={onClick} className={`${classes['modal__close']}`}>
      <img src={modalCloseIcon} alt="Close Modal" />
    </button>
  );
};

Modal.Content = ({ children }) => {
  return (
    <div className={`${classes['modal__content']}`}>
      {children}
    </div>
  );
};

export default Modal;
